import React, { useEffect, useState } from 'react'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import ItemsRequestsApp from './ItemsRequestsApp'
import { IRequestLogModel } from '.'
import { ISearchParam } from '../BaseApp'
import GridData from '../../components/GridData/GridData'
import { IDataDisplayerPagination } from '../../components/DataDisplayer/DataDisplayer'
import BasicModalWindow from '../../components/BasicModalWIndow'
import BasicDataViewer from '../../components/DataDisplayer/BasicDataViewer'
import { ICellRendererParams } from 'ag-grid-community'
import Attachments from '../../components/Attachments'

interface IRequestLogProps {
    requestNumber: string,
    forceRefresh?: (status: boolean) => void,
    forceRefreshStatus?: boolean,
    forceRefreshRequest?: (status: boolean) => void,
}

export default function RequestLog(props: IRequestLogProps) {

    const { requestNumber, forceRefresh, forceRefreshStatus } = props

    const itemsRequestApp = new ItemsRequestsApp()

    const [open, setOpen] = useState<boolean>(false)

    const [record, setRecord] = useState<IRequestLogModel>()
    const [records, setRecords] = useState<IRequestLogModel[]>([])
    const [search, setSearch] = useState<string>("")
    const [loading, setLoading] = useState<boolean>(true)
    const [selectedItems, setSelectedItems] = useState<IRequestLogModel[]>([])
    const [searchParams, setSearchParams] = useState<ISearchParam[]>([])
    const [pagination, setPagination] = useState<IDataDisplayerPagination>({
        count: 0,
        current_page: 0,
        total_pages: 0
    })

    /**
     * Load items
     */
    const loadRecords = (
        page: number, 
        search: string | null, 
        disablePagination: boolean, 
        addItems?: boolean, 
        searchParams?: ISearchParam[]
    ) => {
        return itemsRequestApp.requestLogList(
            requestNumber,
            page,
            search,
            disablePagination,
            addItems,
            searchParams
        )
    }

    const renderClickableCell = (params: ICellRendererParams<IRequestLogModel>) => {

        return <h3 className="title" style={{ cursor: "pointer" }} onClick={() => {
            if (!params.data){
                return;
            }
            setRecord(params.data)
            setOpen(true)
        }}>{params.value}</h3>
    }

    return(
        <div className="item-request-log-container">

            <BasicModalWindow
                shown={open}
                handleClose={() => setOpen(false)}
                size="sm"
                showHeader
                title={requestNumber}
                actionButtonsBottom
                actionButtons={[
                    {
                        label: "Close",
                        color: "error",
                        onClick: () => setOpen(false)
                    }
                ]}
            >
                {record && <BasicDataViewer items={[
                    {
                        type: "text",
                        label: "Request No.",
                        value: record.request_number
                    },
                    {
                        type: "status",
                        label: "Action",
                        value: record.action
                    },
                    {
                        type: "text",
                        label: "Created by",
                        value: record.created_by_name
                    },
                    {
                        type: "date",
                        label: "Date created",
                        value: record.date_created
                    },
                    {
                        type: "text",
                        label: "Note",
                        value: record.note,
                        displayLabelNextLine: true,
                    },
                ]} />}
                {record && record.attachments && <div className="view-update-request-record-attachments"><Attachments attachments={record.attachments} setAttachments={(attachments) => {}} disableDelete disableUpload label="Attachments" showNothingMessage /></div>}
            </BasicModalWindow>

            <SectionBoxContainer
                showTitle
                title="Request Log"
            >
                <GridData 
                    items={records}
                    columns={[
                        {
                            field: "request_number",
                            headerName: "Request No.",
                            width: 250,
                            cellRenderer: (params: ICellRendererParams<IRequestLogModel>) => {
                                return renderClickableCell(params)
                            }
                        },
                        {
                            field: "action",
                            headerName: "Action",
                            type: "status",
                            width: 200
                        },
                        {
                            field: "note",
                            headerName: "Note",
                            type: "text",
                            width: 300,
                            cellRenderer: (params: ICellRendererParams<IRequestLogModel>) => {
                                return renderClickableCell(params)
                            }
                        },
                        {
                            field: "created_by_name",
                            headerName: "Created by",
                            width: 250,
                        },
                        {
                            field: "date_created",
                            headerName: "Created on",
                            type: "date",
                            width: 250
                        },
                    ]}
                    selectedItems={selectedItems}
                    pagination={pagination}
                    search={search}
                    searchParams={searchParams}
                    loading={loading}
                    actionButtons={[
                        {
                            icon: "show",
                            isIconButton: true,
                            onClick(data, dispatch, navigate) {
                                if (!data){
                                    return;
                                }
                                setRecord((data as IRequestLogModel))
                                setOpen(true)
                            },
                        }
                    ]}
                    headerOptions={[]}
                    handleLoadItems={loadRecords}
                    updateSearch={(search) => setSearch(search)}
                    setSelectedItems={(items) => setSelectedItems(items)}
                    onDeleteItem={itemsRequestApp.deleteInstance}
                    onDeleteManyItems={itemsRequestApp.deleteManyInstances}
                    deleteItem={(id, dispatch) => {}}
                    updateLoading={(loading) => setLoading(loading)}
                    updateItemSearchParams={(params) => setSearchParams(params)}
                    addNewItem={(item, dispatch) => {}}
                    updateItem={(i, d) => {}}
                    updateAllItems={(i, d) => setRecords(i)}
                    updateItemsPagination={(pagination) => setPagination(pagination)}
                    config={{
                        viewItemLink: "",
                        editItemLink: "",
                        disableDelete: true,
                        disableSelect: true,
                    }}
                    forceRefreshStatus={forceRefreshStatus}
                    forceRefresh={forceRefresh}
                />
            </SectionBoxContainer>
        </div>
    )
}